import { decamelizeKeys } from "humps";
import { mapValues, omitBy, reduce, startCase } from "lodash";
import { isEmpty } from "lodash";
import { ExportCategories, ExportFields, ExportFilterGroups } from "PFApp/analytics/types/export_analytics";
import { Filter, Value } from "PFTypes";

export const getCategoryTitle = (id = "") => startCase(id.split("-")[0]);

export const getFieldsSortOrder = (items: ExportCategories) =>
  reduce(
    items,
    (order: string[], fields: ExportFields, categoryKey: string) => [
      ...order,
      ...Object.keys(fields).map((fieldKey) => `${categoryKey}-${fieldKey}`)
    ],
    []
  );

export const findMatchingFields = (categories: ExportCategories, term = "") =>
  omitBy(
    mapValues(categories, (fields: ExportFields) => {
      const filteredFields = omitBy(fields, (field) => !field.title.toLowerCase().includes(term));
      return isEmpty(filteredFields) ? {} : filteredFields;
    }),
    (value) => isEmpty(value)
  );

export const decamelizeFilters = <T extends Filter | Value>(filters: ExportFilterGroups<T>) =>
  decamelizeKeys(filters) as ExportFilterGroups<T>;
